import { EvidenceBoundary } from "@/components/EvidenceBoundary";
import { LayerTag } from "@/components/LayerTag";

const ELEMENT_NUM = ["1", "2", "3", "4", "5", "6"];

export function JourneyAnatomy({ anatomy }) {
  return (
    <div className="space-y-4" data-testid="journey-anatomy">
      {anatomy.map((a, i) => {
        const isBoundary = Array.isArray(a.private);
        return (
          <div
            key={a.element}
            className="animate-fade-up rounded-2xl border border-stone-200 bg-white p-5 shadow-sm sm:p-6"
            style={{ animationDelay: `${i * 60}ms` }}
            data-testid={`anatomy-item-${i + 1}`}
          >
            <div className="flex items-start gap-4">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-stone-300 font-mono text-sm text-mill-muted">
                {ELEMENT_NUM[i]}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-3">
                  <h3 className="font-display text-lg font-semibold text-mill-ink">{a.element}</h3>
                  {a.layer && <LayerTag layer={a.layer} />}
                </div>
                {a.detail && <p className="mt-1.5 text-sm leading-relaxed text-mill-muted">{a.detail}</p>}

                {a.chips && (
                  <div className="mt-3 flex flex-wrap gap-2">
                    {a.chips.map((c) => (
                      <span
                        key={c}
                        data-testid={`sor-chip-${c.toLowerCase().replace(/\s/g, "-")}`}
                        className="rounded-full border border-stone-200 bg-mill-alt px-3 py-1 text-xs font-medium uppercase tracking-wide text-mill-muted"
                      >
                        {c}
                      </span>
                    ))}
                  </div>
                )}

                {isBoundary && (
                  <div className="mt-4">
                    <EvidenceBoundary privateItems={a.private} receiptItems={a.receipt} />
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
